// Mirror of SonyDocument.Status in appquickchat/models.py — keep in sync.
export enum SonyDocumentStatusEnum {
  DEPLOYED = 'deployed',
  IN_RETRAIN = 'in_retrain',
  RETRAIN_CONTENT_READY = 'retrain_content_ready',
  APP_ARTICLES_CREATED = 'app_articles_created',
  SUPERSEDED = 'superseded',
  BATCH_RETRAIN_STARTED = 'batch_retrain_started',
  FAIL = 'fail',
  SAVED = 'saved',
  ARCHIVED = 'archived',
}

// Mirror of SonyDocument.ObjectType in appquickchat/models.py — keep in sync.
export enum SonyObjectTypeEnum {
  MODEL = 'model',
  CATEGORY = 'category',
  SUPPORT_ARTICLE = 'support-article',
  COMPATIBILITY_ARTICLE = 'compatibility-article',
  QUALITY_ISSUE_ARTICLE = 'quality-issue-article',
  MANUALS = 'manuals',
  HELP_GUIDES = 'help-guides',
  DOWNLOAD = 'download',
  UNSET = 'unset',
}

export type SonyDocumentsFilter = {
  status?: SonyDocumentStatusEnum;
  object_type?: SonyObjectTypeEnum;
  external_id?: string;
  title?: string;
};

export type SonyAdminDocumentDto = {
  id: number;
  external_id: string;
  object_type: SonyObjectTypeEnum;
  title: string;
  locale: string;
  status: SonyDocumentStatusEnum;
  version: number | null;
  version_timestamp: number | null;
  retrain_id: number | null;
  tags: string[];
  related_models: string[];
  countries: string[];
  view_url: string;
  summary_text_content: string;
  fail_message: string | null;
  created_timestamp: string;
  last_updated_timestamp: string;
};

export type SonyAdminDocumentsListDto = {
  items: SonyAdminDocumentDto[];
  offset: number;
  count: number | null;
  count_capped: boolean;
};

export type SonyAdminArticleDto = {
  id: number;
  title: string | null;
  content: string;
  version: number | null;
  last_updated_timestamp: string;
};

export type SonyAdminDocumentDetailDto = {
  rows: SonyAdminDocumentDto[];
  history_total: number;
  staged: SonyAdminDocumentDto | null;
  article: SonyAdminArticleDto | null;
  preview_chunk_count: number;
  live_chunk_count: number;
  pending_embed_count: number;
  current_deploy_id: number | null;
  retrain_in_progress: boolean;
  pipeline_in_progress: boolean;
  deploy_in_progress: boolean;
  payload: Record<string, unknown> | null;
};
